import {useQueryClient} from '@tanstack/react-query';
import {createQuery} from 'react-query-kit';
import queryDemoWrapper from 'utils/query-utils/query-demo-wraper';
import {FullUserProfile} from '../../../interfaces/user-profile';
import {
  fetchCompanyUserProfile,
  FetchCompanyUserProfilePayload,
} from '../../../repositories/instill/queries/fetch-company-user-profile';
import {RQ_COMPANY_USER_PROFILE} from './query-keys';

type Response = FullUserProfile | undefined;
type Payload = FetchCompanyUserProfilePayload;

export const useCompanyUserProfile = createQuery<Response, Payload>({
  primaryKey: RQ_COMPANY_USER_PROFILE,
  queryFn: queryDemoWrapper(
    async ({queryKey: [_, variables]}) => {
      if (!variables.userProfileUuid) {
        return Promise.reject();
      }

      return await fetchCompanyUserProfile({
        companyUuid: variables.companyUuid,
        userProfileUuid: variables.userProfileUuid,
      });
    },

    async ({queryKey: [_, variables]}) => {
      const {dummyCompanyFullUserProfiles} = await import(
        'ui/@demo-data/user-profile'
      );

      const selectedEmployee = dummyCompanyFullUserProfiles.find(
        (employee) => employee.uuid === variables.userProfileUuid
      );

      return selectedEmployee;
    }
  ),
});

export const useSyncSetCompanyUserProfile = () => {
  const queryClient = useQueryClient();

  const syncSetCompanyUserProfile = (
    companyUserProfileVariables: Payload,
    newCompanyUserProfile: Response
  ) => {
    queryClient.setQueryData(
      [RQ_COMPANY_USER_PROFILE, companyUserProfileVariables],
      newCompanyUserProfile
    );
  };

  return syncSetCompanyUserProfile;
};
